import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import { title } from '@/units'
import { hasOwnProp } from '@/utils'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',
  base: process.env.BASE_URL
})

router.beforeEach((to, from, next) => {
  const authen: boolean = store.getters['APP.AUTH/auth']

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (authen) next()
    else next({ name: 'auth' })
  } else {
    if (authen && to.name !== 'warning') next({ name: 'dash' })
    else next()
  }
})

router.afterEach((to, from) => {
  title(
    hasOwnProp(to.meta, 'title')
      ? to.meta.title
      : ''
  )
})

export default router